"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputFields = void 0;
var React = require("react");
require("./index.scss");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
__exportStar(require("./LocaleFields"), exports);
var validationError = function (validationErrors, field) {
    var _a;
    var error = (_a = validationErrors === null || validationErrors === void 0 ? void 0 : validationErrors[field]) === null || _a === void 0 ? void 0 : _a[0];
    return error ? React.createElement("div", { className: 'validation-error' }, error) : null;
};
var InputFields = function (props) {
    return (React.createElement("div", { className: 'reports-modal-input-fields-container' },
        React.createElement("div", { className: 'reports-modal-input-field' },
            React.createElement("label", { className: 'reports-modal-input-field-label' }, (0, translation_1.getLocalization)('management/reports/modal/template/inputField/templateName/placeholder')),
            React.createElement(sok_ui_1.TextInput, { placeholder: (0, translation_1.getLocalization)('management/reports/modal/template/inputField/templateName/placeholder'), className: 'reports-modal-input-field-input', onChange: function (e) {
                    return props.onNameChange(e.target.value);
                }, value: props.name, disabled: props.disabled }),
            React.createElement(InputErrorMessage, { errors: props.reportTemplateNameValidationErrors }),
            validationError(props.validationErrors, 'name')),
        React.createElement("div", { className: 'reports-modal-input-field' },
            React.createElement("label", { className: 'reports-modal-input-field-label' }, (0, translation_1.getLocalization)('management/reports/modal/template/inputField/templateDescription/label')),
            React.createElement(sok_ui_1.TextInput, { placeholder: (0, translation_1.getLocalization)('management/reports/modal/template/inputField/templateDescription/placeholder'), className: 'reports-modal-input-field-input', onChange: function (e) {
                    return props.onDescriptionChange(e.target.value);
                }, value: props.description, disabled: props.disabled }),
            validationError(props.validationErrors, 'description'))));
};
exports.InputFields = InputFields;
var InputErrorMessage = function (props) {
    if (props.errors.length === 0)
        return null;
    return (React.createElement("span", { className: "validation-error" }, (0, translation_1.getLocalization)("management/reports/modal/template/inputField/templateName/".concat(props.errors[0]))));
};
